// Cart upsell (snippets/cart-upsell.liquid). Delegated listeners, because the cart
// HTML is re-rendered after every cart change and inline scripts would not re-run.
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-upsell-select]');
  if (!select) return;

  const upsell = select.closest('[data-cart-upsell]');
  const option = select.selectedOptions[0];
  upsell.querySelector('[data-upsell-add]').dataset.variantId = option.value;
  upsell.querySelector('[data-upsell-price]').textContent = option.dataset.price;

  const img = upsell.querySelector('[data-upsell-image]');
  if (img && option.dataset.image) {
    img.removeAttribute('srcset');
    img.src = option.dataset.image;
  }
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-upsell-add]');
  if (!button) return;

  event.preventDefault();
  const Cart = customElements.get('cart-element');
  // Hidden "_" property: invisible to shoppers, kept on the order in Shopify admin
  const items = [{ id: Number(button.dataset.variantId), quantity: 1, properties: { '_Added via': 'Cart upsell' } }];
  button.setAttribute('aria-busy', 'true');

  try {
    if (Cart && Cart.addItems) {
      await Cart.addItems({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items, sections: Cart.sections })
      });
    } else {
      const res = await fetch(`${window.Shopify.routes.cart_add}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error(res.statusText);
      window.location.reload();
    }
    // Custom event for Settings → Customer events (forward to GA4 / Meta from there)
    try { window.Shopify?.analytics?.publish?.('cart_upsell_added', { variant_id: items[0].id }); } catch (e) { /* ignore */ }
  } catch (e) {
    button.setAttribute('aria-busy', 'false');
    button.textContent = 'Try again';
  }
});
